import React from 'react';

const formatCurrency = (value) => {
  if (value == null || isNaN(value)) {
    return '$0';
  }
  return `$${Number(value).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;
};

const TraditionalRentalYearlyTable = ({ yearlyData }) => {
  if (!yearlyData || yearlyData.length === 0) {
    return <div className="text-center text-gray-500">No data available.</div>;
  }

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full bg-white border border-gray-300 rounded-lg overflow-hidden">
        <thead className="bg-gray-100">
          <tr>
            <th className="px-4 py-2 text-sm font-semibold border">Year</th>
            <th className="px-4 py-2 text-sm font-semibold border">Asset Value</th>
            <th className="px-4 py-2 text-sm font-semibold border">Rent Collected</th>
            <th className="px-4 py-2 text-sm font-semibold border">Vacancy Loss</th>
            <th className="px-4 py-2 text-sm font-semibold border">Net Rent</th>
            <th className="px-4 py-2 text-sm font-semibold border">Tax Paid</th>
            <th className="px-4 py-2 text-sm font-semibold border">Insurance Paid</th>
            <th className="px-4 py-2 text-sm font-semibold border">Maintenance Paid</th>
            <th className="px-4 py-2 text-sm font-semibold border">Admin Fee Paid</th>
            <th className="px-4 py-2 text-sm font-semibold border">Total Expenses</th>
            <th className="px-4 py-2 text-sm font-semibold border">Net Cashflow</th>
            <th className="px-4 py-2 text-sm font-semibold border">Cumulative Revenue</th>
            <th className="px-4 py-2 text-sm font-semibold border">Cumulative Net Cashflow</th>
          </tr>
        </thead>
        <tbody>
          {yearlyData.map((year) => (
            <tr key={year.year} className="text-center text-xs border-t">
              <td className="px-4 py-2">{year.year}</td>
              <td className="px-4 py-2">{formatCurrency(year.assetValue)}</td>
              <td className="px-4 py-2">{formatCurrency(year.rentCollected)}</td> 
              <td className="px-4 py-2">{formatCurrency(year.vacancyLoss)}</td>
              <td className="px-4 py-2">{formatCurrency(year.netRentCollected)}</td>
              <td className="px-4 py-2">{formatCurrency(year.taxPaid)}</td>
              <td className="px-4 py-2">{formatCurrency(year.insurancePaid)}</td>
              <td className="px-4 py-2">{formatCurrency(year.maintenancePaid)}</td>
              <td className="px-4 py-2">{formatCurrency(year.adminFeePaid)}</td>
              <td className="px-4 py-2">{formatCurrency(year.totalInvestorExpenses)}</td>
              <td className="px-4 py-2">{formatCurrency(year.netCashflowYearly)}</td>
              <td className="px-4 py-2">{formatCurrency(year.cumulativeRevenue)}</td> 
              <td className="px-4 py-2">{formatCurrency(year.cumulativeNetCashflow)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TraditionalRentalYearlyTable;
